// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TimePicker__container-ead3d4 {
  width: 100%;
}

.TimePicker__content-b20d19 {
  height: 52px;
}

.TimePicker__input-e4f02c {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-110);
  background-color: transparent;
  z-index: 2;
  box-sizing: border-box;
}

.TimePicker__input-e4f02c::-webkit-datetime-edit-text {
  display: inline-block;
  padding: 0 2px;
}

.TimePicker__input-e4f02c::-webkit-datetime-edit-hour-field,
.TimePicker__input-e4f02c::-webkit-datetime-edit-minute-field,
.TimePicker__input-e4f02c::-webkit-datetime-edit-second-field,
.TimePicker__input-e4f02c::-webkit-datetime-edit-ampm-field {
  display: inline-block;
  height: 24px;
  padding: 0 2px;
  background-color: transparent;
  border-radius: 4px;
}

.TimePicker__input-e4f02c::-webkit-datetime-edit-hour-field:focus,
.TimePicker__input-e4f02c::-webkit-datetime-edit-minute-field:focus,
.TimePicker__input-e4f02c::-webkit-datetime-edit-second-field:focus,
.TimePicker__input-e4f02c::-webkit-datetime-edit-ampm-field:focus {
  background-color: var(--brand-secondary-40_30);
}

.TimePicker__input-e4f02c::-webkit-calendar-picker-indicator {
  width: 24px;
  height: 24px;
  margin: 0;
  padding: 0;
  opacity: 0;
  cursor: pointer;
}

.TimePicker__hour-12-a7ae07 {
  min-width: 134px;
}

.TimePicker__hour-24-cc5d7b {
  min-width: 105px;
}

.TimePicker__input-flex-d3d8b3 {
  display: flex;
}

.TimePicker__input-icon-edd5ab {
  position: absolute;
  display: flex;
  align-items: center;
  top: 50%;
  transform: translateY(-50%);
  inset-inline-end: 16px;
  background-color: var(--field-background-color);
  z-index: 1;
}

@supports (-moz-appearance: none) {
  .TimePicker__input-icon-edd5ab {
    z-index: 3;
  }
}
.TimePicker__input-icon-edd5ab svg * {
  fill: var(--base-80);
}

.TimePicker__input-icon-edd5ab svg {
  width: 18px;
  height: 18px;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/TimePicker/TimePicker.style.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,6BAAA;EACA,UAAA;EACA,sBAAA;AACF;;AAEA;EACE,qBAAA;EACA,cAAA;AACF;;AAEA;;;;EAIE,qBAAA;EACA,YAAA;EACA,cAAA;EACA,6BAAA;EACA,kBAAA;AACF;;AAEA;;;;EAIE,8CAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,2BAAA;EACA,sBAAA;EACA,+CAAA;EACA,UAAA;AACF;;AAEA;EACE;IACE,UAAA;EACF;AACF;AAEA;EACE,oBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;AAAF","sourcesContent":[".container {\n  width: 100%;\n}\n\n.content {\n  height: 52px;\n}\n\n.input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-110);\n  background-color: transparent;\n  z-index: 2;\n  box-sizing: border-box;\n}\n\n.input::-webkit-datetime-edit-text {\n  display: inline-block;\n  padding: 0 2px;\n}\n\n.input::-webkit-datetime-edit-hour-field,\n.input::-webkit-datetime-edit-minute-field,\n.input::-webkit-datetime-edit-second-field,\n.input::-webkit-datetime-edit-ampm-field {\n  display: inline-block;\n  height: 24px;\n  padding: 0 2px;\n  background-color: transparent;\n  border-radius: 4px;\n}\n\n.input::-webkit-datetime-edit-hour-field:focus,\n.input::-webkit-datetime-edit-minute-field:focus,\n.input::-webkit-datetime-edit-second-field:focus,\n.input::-webkit-datetime-edit-ampm-field:focus {\n  background-color: var(--brand-secondary-40_30);\n}\n\n.input::-webkit-calendar-picker-indicator {\n  width: 24px;\n  height: 24px;\n  margin: 0;\n  padding: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.hour-12 {\n  min-width: 134px;\n}\n\n.hour-24 {\n  min-width: 105px;\n}\n\n.input-flex {\n  display: flex;\n}\n\n.input-icon {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  top: 50%;\n  transform: translateY(-50%);\n  inset-inline-end: 16px;\n  background-color: var(--field-background-color);\n  z-index: 1;\n}\n\n@supports (-moz-appearance: none) {\n  .input-icon {\n    z-index: 3;\n  }\n}\n\n.input-icon svg * {\n  fill: var(--base-80);\n}\n\n.input-icon svg {\n  width: 18px;\n  height: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TimePicker__container-ead3d4`,
	"content": `TimePicker__content-b20d19`,
	"input": `TimePicker__input-e4f02c`,
	"hour-12": `TimePicker__hour-12-a7ae07`,
	"hour12": `TimePicker__hour-12-a7ae07`,
	"hour-24": `TimePicker__hour-24-cc5d7b`,
	"hour24": `TimePicker__hour-24-cc5d7b`,
	"input-flex": `TimePicker__input-flex-d3d8b3`,
	"inputFlex": `TimePicker__input-flex-d3d8b3`,
	"input-icon": `TimePicker__input-icon-edd5ab`,
	"inputIcon": `TimePicker__input-icon-edd5ab`
};
module.exports = ___CSS_LOADER_EXPORT___;
